"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Vector2 {
    constructor(x, y) {
        this.x = x;
        this.y = y;
    }
    static Add(v1, v2) {
        return new Vector2(v1.x + v2.x, v1.y + v2.y);
    }
    static Subtract(v1, v2) {
        return new Vector2(v1.x - v2.x, v1.y - v2.y);
    }
    static Multiply(v1, scalar) {
        return new Vector2(v1.x * scalar, v1.y * scalar);
    }
    add(v) {
        this.x += v.x;
        this.y += v.y;
    }
    subtract(v) {
        this.x -= v.x;
        this.y -= v.y;
    }
    multiply(scalar) {
        this.x *= scalar;
        this.y *= scalar;
    }
    toString() {
        return `[${this.x.toFixed(6)}, ${this.y.toFixed(6)}]`;
    }
}
exports.Vector2 = Vector2;
